var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { assign, guid } from '@tencent/glue-util-helper';
import { Emitter } from '@tencent/glue-util-emitter';
import { getKeys } from '@tencent/glue-util-types';
import { isTransformProp, isAnimationProp, isFixProp, pxToRem, isRotateProps, } from '@tencent/xj-components';
import { styleObjToCss } from '../utils/css';
import { H5AnimationExecutor } from './H5AnimationExecutor';
var StyleTransform = /** @class */ (function (_super) {
    __extends(StyleTransform, _super);
    function StyleTransform(pixel) {
        var _this = _super.call(this) || this;
        _this.id = guid();
        _this.el = null;
        _this.style = {};
        _this.animationStyle = {};
        _this.pixel = pixel;
        return _this;
    }
    StyleTransform.prototype.getId = function () {
        return this.id;
    };
    StyleTransform.prototype.getElement = function () {
        return this.el;
    };
    StyleTransform.prototype.setElement = function (el) {
        var _this = this;
        if (el !== this.el) {
            this.el = el;
            getKeys(this.animationStyle).forEach(function (key) {
                var animation = _this.animationStyle[key];
                if (animation == null) {
                    return;
                }
            });
        }
    };
    StyleTransform.prototype.setStyle = function (style) {
        var _this = this;
        var animation = this.setNumericStyle(style);
        var oldAnimation = this.animationStyle;
        var cachedAnimation = {};
        var newAnimation = {};
        this.animationStyle = {};
        getKeys(animation).forEach(function (key) {
            var value = animation[key];
            var old = oldAnimation[key];
            if (value == null) {
                return;
            }
            if (old && old.getInstance() === value) {
                cachedAnimation[key] = old;
                delete oldAnimation[key];
            }
            else {
                newAnimation[key] = value;
            }
        });
        getKeys(cachedAnimation).forEach(function (key) {
            var executor = cachedAnimation[key];
            if (!executor) {
                return;
            }
            _this.animationStyle[key] = executor;
        });
        getKeys(newAnimation).forEach(function (key) {
            var instance = newAnimation[key];
            if (!instance) {
                return;
            }
            _this.animationStyle[key] = new H5AnimationExecutor(_this, key, instance);
        });
        getKeys(oldAnimation).forEach(function (key) {
            var executor = oldAnimation[key];
            if (!executor) {
                return;
            }
            executor.dispose();
        });
    };
    StyleTransform.prototype.updateAnimationStyle = function () {
        this.el && (this.el.style.cssText = styleObjToCss(this.getStyle()));
    };
    StyleTransform.prototype.getStyle = function () {
        var _this = this;
        var source = __assign({}, this.style);
        getKeys(this.animationStyle).forEach(function (key) {
            var _a;
            var animation = _this.animationStyle[key];
            if (!animation) {
                return;
            }
            assign(source, (_a = {}, _a[key] = animation.getCurrentValue(), _a));
        });
        var css = {};
        var transformContent = [];
        getKeys(source).forEach(function (cssKey) {
            var _a;
            var cssValue = source[cssKey];
            if (cssValue == null) {
                return;
            }
            var computedValue = cssValue;
            // 字符串不转 .eg: 1px
            // px number转rem
            if (isFixProp(cssKey) && typeof cssValue === 'number' && cssValue !== 0) {
                computedValue = _this.pixel ? "".concat(cssValue, "px") : "".concat(pxToRem(cssValue), "rem");
            }
            // 弧度转角度
            if (isRotateProps(cssKey) && typeof cssValue === 'number') {
                computedValue = "".concat((cssValue * 180 / Math.PI).toFixed(4), "deg");
            }
            // transform只能有一个，最后合并再添加
            if (isTransformProp(cssKey)) {
                transformContent.push("".concat(cssKey, "(").concat(computedValue, ")"));
                return;
            }
            if (cssKey === 'backgroundImage') {
                computedValue = "url(".concat(cssValue, ")");
            }
            assign(css, (_a = {}, _a[cssKey] = computedValue, _a));
        });
        if (transformContent.length) {
            css.transform = transformContent.join(' ');
        }
        return css;
    };
    StyleTransform.prototype.dispose = function () {
    };
    StyleTransform.prototype.setNumericStyle = function (style) {
        var _this = this;
        var animation = {};
        this.style = {};
        getKeys(style).forEach(function (key) {
            var _a;
            var value = style[key];
            if (value == null) {
                return;
            }
            if (typeof value === 'object') {
                if (isAnimationProp(key)) {
                    animation[key] = value;
                    return;
                }
                throw new Error("invalid animation key = ".concat(key));
            }
            assign(_this.style, (_a = {}, _a[key] = value, _a));
        });
        return animation;
    };
    return StyleTransform;
}(Emitter));
export { StyleTransform };
